import { SubmissionError } from "redux-form";
import { ThunkResult } from "../../main/reducers/IMainAppState";

export function APIGet(url: string, requestInit?: RequestInit): ThunkResult<Promise<Response>> {
    return async () => {
        return await RaangeFetch(url, {
            ...requestInit,
            method: 'get',
        });
    }
}

export function APIPost(url: string, requestInit?: RequestInit): ThunkResult<Promise<Response>> {
    return async () => {
        return await RaangeFetch(url, {
            ...requestInit,
            method: 'post',
        });
    };
}

export function APIPut(url: string, requestInit?: RequestInit): ThunkResult<Promise<Response>> {
    return async () => {
        return await RaangeFetch(url, {
            ...requestInit,
            method: 'put'
        });
    };
}

async function RaangeFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    const response: Response = await fetch(input, init);
    if(!response.ok) {
        const errorObj: {code: string, detail?: string} = await response.json();
        if(response.status === 400) {
            if(errorObj.detail) {
                const regex: RegExp = new RegExp('body\.([a-zA-Z]+)');
                const fieldNameMatches = errorObj.detail.match(regex);
                if (fieldNameMatches) {
                    const fieldName = fieldNameMatches[1];
                    throw new SubmissionError({
                        [fieldName]: errorObj.detail
                    });
                }
            } else if(errorObj.code) {
                throw new Error(errorObj.code);
            }
        }

        throw new Error(errorObj.detail);
    }
    return response;
}